export default "__VITE_ASSET__27b4dce3__"